export var createRoutingRulesApi = function (baseUrl, http) {
    var apiUrl = baseUrl + "/routing-rules";
    return {
        getByTargetGroupIds: function (dto) { return http.post(apiUrl + "/groups", dto); }
    };
};
//# sourceMappingURL=index.js.map